import { render, staticRenderFns } from "./CoSoLuuTruForm.vue?vue&type=template&id=a41d74f8&scoped=true&"
import script from "./CoSoLuuTruForm.vue?vue&type=script&lang=js&"
export * from "./CoSoLuuTruForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41d74f8",
  null
  
)

export default component.exports